export default __webpack_public_path__ + "static/media/allStaff.d38b4f32.svg";